/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
  async campaignIndex(data?: any) {
    return camelize(
      await $axios.get(`/dev/campaigns`, snakelize({ params: data }))
    );
  },

  async brandShow(data?: any) {
    return camelize(
      await $axios.get(`/dev/brand/${data.id}`, snakelize({ params: data }))
    );
  },

  async updatesAmbassadorRules(data?: any) {
    return camelize(
      await $axios.post(`/dev/updates-ambassador-rules`, snakelize(data))
    );
  },

  async updatesCampaignRules(data?: any) {
    return camelize(
      await $axios.post(
        `/dev/updates-campaign-rules/${data.campaignId}`,
        snakelize(data)
      )
    );
  },

  async campaignRules(data?: any) {
    return camelize(
      await $axios.get(
        `/dev/campaign/${data.campaignId}/rules`,
        snakelize({ params: data })
      )
    );
  },

  async campaignRulesOld(data?: any) {
    return camelize(
      await $axios.get(
        `/dev/campaign/${data.campaignId}/rules/old`,
        snakelize({ params: data })
      )
    );
  },

  // **** SAMPLES ****

  // 가이드라인룰 목록
  // async index(data?: any) {
  //   return camelize(
  //     await $axios.get(`/guideline-rules`, snakelize({ params: data }))
  //   );
  // },

  // async create(data?: any) {
  //   return camelize(
  //     await $axios.get(`/product/rules/create`, snakelize({ params: data }))
  //   );
  // },

  // async store(data?: any) {
  //   return camelize(await $axios.post("/guideline-rules", snakelize(data)));
  // },

  // // WIP
  // async updatesAmbassadorRules(data?: any) {
  //   return camelize(
  //     await $axios.post(
  //       "/guideline-rules/updates-ambassador-rules",
  //       snakelize(data)
  //     )
  //   );
  // },

  // //  가이드 이미지 업로드
  // async uploadImage(data?: any) {
  //   const formData = new FormData();
  //   formData.append("image", data.image);
  //   formData.append("brand_token", data.brandToken);
  //   return camelize(
  //     await $axios.post("/guideline-rules/image/upload", formData)
  //   );
  // },

  // async delete(data?: any) {
  //   return camelize(await $axios.delete(`/guide/${data.id}`))
  // },
});
